"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestMethods = void 0;
/**
 * Utilities for creating HTTP requests with the transport client
 */
var RequestMethods;
(function (RequestMethods) {
    RequestMethods["get"] = "GET";
    RequestMethods["GET"] = "GET";
    RequestMethods["post"] = "POST";
    RequestMethods["POST"] = "POST";
    RequestMethods["put"] = "PUT";
    RequestMethods["PUT"] = "PUT";
    RequestMethods["delete"] = "DELETE";
    RequestMethods["DELETE"] = "DELETE";
})(RequestMethods = exports.RequestMethods || (exports.RequestMethods = {}));
